exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.widget-embed-step-header {\n    font-weight: bold;\n    font-size: 17px;\n}\n.embed-instructions-button {\n    position: absolute;\n    left: 15px;\n    bottom: 15px;\n    cursor: pointer;\n    color: #00aef1;\n}\n", ""]);

// exports
